/* ── Add-to-cart pixel de-duplication ──────────────────────────────────────
   One add-to-cart click emitted TWO product_added_to_cart events into Shopify
   Customer Events (Google & YouTube pixel 1270612241 -> GA4 G-H8DRXSQ9P5 and
   Ads AW-11278991347, plus Meta). The cart was always correct: one
   /cart/add.js POST, one unit. Analytics-only, but it 2x-inflates any
   add_to_cart conversion action, remarketing audience and bidding signal.

   ROOT CAUSE (measured, not inferred). Shopify's web-pixels-manager has TWO
   independent add-to-cart detectors:
     1. handleSubmitToCartAdd -- bound directly on every form[action] and
        publishing product_added_to_cart off the SUBMIT EVENT itself, with no
        network request involved. (Visible via jQuery._data(form,'events').submit.)
     2. its /cart/add request interception.
   A normal theme trips exactly one: a non-AJAX theme submits the form, an AJAX
   theme skips the form and fetches. wpbingo does BOTH -- it lets the form
   submit, then cancels navigation and posts the cart add over AJAX
   (ShopifyAPI.addItemFromForm) -- so both detectors fire. Hence two events.

   Proven by isolation on a live PDP, counting window.dataLayer directly on a
   freshly loaded page with no hooks installed (hooking dataLayer.push
   repeatedly nests wrappers and inflates every count -- do not do it):
     real button click ............................ 2 events, cart 1
     bare fetch / XHR / jQuery.ajax to /cart/add.js  1 event,  cart 1
     body as JSON / urlencoded / multipart ........  1 event each
   So neither the transport nor the body shape matters; only whether a submit
   event is dispatched.

   FIX: intercept the submit button's click in the CAPTURE phase, cancel it so
   no submit event is dispatched at all, then invoke wpbingo's delegated
   add-to-cart handler DIRECTLY (the one bound on <body> for
   '[data-product-form]', wpbingo.js:3634). Calling it by reference runs the
   real add path -- AJAX post, cart drawer, spinner, is-added state, header
   count -- while never dispatching an event that detector #1 can see.

   NOTE for anyone revisiting: jQuery(form).trigger('submit') does NOT work
   here and was the first (failed) attempt. It avoids the native event, but
   handleSubmitToCartAdd is jQuery-bound, so jQuery's synthetic trigger still
   calls it and the duplicate survives. It must be bypassed by invoking the
   delegated handler directly.

   Verified after this change: 1 event, cart qty 1, drawer opens, is-added set.
   Falls through to untouched native behaviour if jQuery or the wpbingo handler
   is missing, so the worst case is the pre-existing double event, never a dead
   button. No [data-product-form] on a PDP has a [required] input, so
   cancelling native submission forfeits no HTML5 validation. */
(function () {
  if (window.__ajAtcDedupe) return;
  window.__ajAtcDedupe = true;

  var SELECTOR = '[data-product-form]';

  /* Resolved at click time, not load time: wpbingo binds formOverride() well
     after this file parses, and the handler list can be rebuilt. */
  function wpbingoHandler(jq) {
    try {
      var bound = (jq._data(document.body, 'events') || {}).submit || [];
      for (var i = 0; i < bound.length; i++) {
        if (bound[i].selector === SELECTOR) return bound[i].handler;
      }
    } catch (e) {}
    return null;
  }

  document.addEventListener('click', function (ev) {
    if (ev.defaultPrevented) return;
    if (ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
    if (!ev.target || !ev.target.closest) return;

    var btn = ev.target.closest('button[type="submit"], input[type="submit"]');
    if (!btn || btn.disabled) return;

    var form = btn.closest(SELECTOR);
    if (!form) return;

    var jq = window.jQuery;
    if (!jq || !jq._data || !jq.Event) return;

    var handler = wpbingoHandler(jq);
    if (!handler) return;   // nothing to hand off to -- leave native alone

    ev.preventDefault();

    /* Shaped like the event wpbingo's handler reads: it uses evt.target for
       the form and evt.preventDefault(), and relies on `this` being the form. */
    var fake = jq.Event('submit');
    fake.target = form;
    fake.currentTarget = form;
    handler.call(form, fake);
  }, true);
})();
